import React, { useState, useEffect } from 'react';
import DefaultLayout from '../layouts/DefaultLayout';
import { DataGrid, GridActionsCellItem } from '@mui/x-data-grid';
import { Link } from 'react-router-dom';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { defaultDisplayDateFormat } from '../utils/Utilities';
import { Grid } from '@mui/material';

export default function MemberInfoListPage() {
  
  const [members, setMembers] = useState([]);
  
  useEffect(() => {
    fetch(process.env.REACT_APP_API_DOMAIN + "/members/members/", {
      method:'GET',
      credentials: 'include' 
    })
    .then(res => {
      if (!res.ok) {
        if ([401, 403].includes(res.status)) {
          throw Error('Not Authenticated');
        } else {
          throw Error(res.statusText);
        }
      }
      return res.json()
    })
    .then(
      (result) => {
        setMembers(result.results);
      },
      (error) => {
        console.log(error.message);
      }
    );
  }, []);
    
  const columns = [
    { field: 'actions', type: 'actions', width: 30,
      getActions: (params) => [
        <GridActionsCellItem
        component={Link} to={'/members/'+params.row.id}
        icon={<VisibilityIcon/>} label="Veure soci"
        showInMenu={false} />,
      ]
    },
    { field: 'id', type: 'number', headerName: 'ID' },
    {
      field: 'nom',
      headerName: "Nom",
      width: 240,
      valueGetter: (params) => {
        console.log({ params });
        let result = [];
        if (params.row.person && params.row.person.user) {
          if (params.row.person.user.first_name) {
            result.push(params.row.person.user.first_name);
          }
          if (params.row.person.user.last_name) {
            result.push(params.row.person.user.last_name);
          }
        } else {
          result = ["Unknown"];
        }
        return result.join(" ");
      }
    },
    { field: 'member_number', type: 'number', headerName: 'Núm. de soci', width: 100 },
    { field: 'active', headerName: 'Actiu', width: 100 },
    { field: 'activation_date', type: 'date', headerName: 'Data Alta', editable: true, width: 120,
      valueFormatter: params => { 
        return (params.value !== null)? defaultDisplayDateFormat(params.value) : null
      }
    },
    { field: 'deactivation_date', type: 'date', headerName: 'Data Baixa', width: 120,
      valueFormatter: params => {
        return (params.value !== null)? defaultDisplayDateFormat(params.value) : null
      }
    },
  ]

  return (
    <DefaultLayout>
      <Grid item xs={12}>
        <DataGrid rows={members} columns={columns} autoHeight
          initialState={{
            sorting: {
              sortModel: [{ field: 'member_number', sort: 'asc' }],
            },
          }}
        />
      </Grid>
    </DefaultLayout>
  );
};
